import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import Navigation from './templates/nav/Nav';

if (document.getElementsByTagName('nav')[0]) {
  const root = ReactDOM.createRoot(document.getElementsByTagName('nav')[0] as HTMLElement);
  root.render(
    <StrictMode>
      <Navigation />
    </StrictMode>,
  );
}
